(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('payment-method', {
            parent: 'entity',
            url: '/payment-method?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.paymentMethod.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/payment-method/payment-methods.html',
                    controller: 'PaymentMethodController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('paymentMethod');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('payment-method-detail', {
            parent: 'entity',
            url: '/payment-method/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.paymentMethod.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/payment-method/payment-method-detail.html',
                    controller: 'PaymentMethodDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('paymentMethod');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PaymentMethod', function($stateParams, PaymentMethod) {
                    return PaymentMethod.get({id : $stateParams.id});
                }]
            }
        })
        .state('payment-method.new', {
            parent: 'payment-method',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/payment-method/payment-method-dialog.html',
                    controller: 'PaymentMethodDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                code: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('payment-method', null, { reload: true });
                }, function() {
                    $state.go('payment-method');
                });
            }]
        })
        .state('payment-method.edit', {
            parent: 'payment-method',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/payment-method/payment-method-dialog.html',
                    controller: 'PaymentMethodDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PaymentMethod', function(PaymentMethod) {
                            return PaymentMethod.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('payment-method', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('payment-method.delete', {
            parent: 'payment-method',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/payment-method/payment-method-delete-dialog.html',
                    controller: 'PaymentMethodDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PaymentMethod', function(PaymentMethod) {
                            return PaymentMethod.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('payment-method', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
